import React, { FC, memo, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useInterval } from '~Hooks';
import RollingNumber from '../RollingNumber';

/** Big, in the button color so the number is the thing on the card. */
const Digits = styled(RollingNumber)`
  font-size: 160px;
  font-weight: 800;
  letter-spacing: -4px;
  color: var(--eposButton);
`;

interface Props {
  /** Where the count starts, in whole seconds. */
  from: number;
  /** Frozen at the current value - used while the terminal is busy. */
  paused: boolean;
  /** Fired once, when the count has passed zero. */
  onExpire: () => void;
}

/**
 * The seconds left, rolling down one per second. Owns the interval and the
 * value, so each tick re-renders this element alone and not the modal.
 */
const Countdown: FC<Props> = ({ from, paused, onExpire }) => {
  const [secondsLeft, setSecondsLeft] = useState(from);

  useInterval(() => setSecondsLeft((prev) => prev - 1), paused ? null : 1000);

  useEffect(() => {
    if (secondsLeft < 0) {
      onExpire();
    }
  }, [secondsLeft, onExpire]);

  return <Digits value={Math.max(0, secondsLeft)} testId="epos-idle-timeout-seconds" />;
};

export default memo(Countdown);
